import { render } from "./ButtonEdit.vue?vue&type=template&id=1df5533c"
import script from "./ButtonEdit.vue?vue&type=script&lang=js"
export * from "./ButtonEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__